import React from 'react'
import '../../assets/css/pages/track_progress/performance-expectation-row.css'
import NgssDimensionTable from '../../components/NgssDimensionTable'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import WorkProductQualityProgressBar from '../../components/WorkProductQualityProgressBar'
library.add(faPlus, faMinus)

class PerformanceExpectationRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isExpanded: false }
  }

  getProgressColumnClasses() {
    const baseClasses = 'pe-progress-bar-column'

    if(this.props.isContainerExpanded) {
      return [baseClasses, 'container-expanded'].join(' ')
    } else {
      return baseClasses
    }
  }

  handleToggleExpansion = ()=>
    this.setState({ isExpanded: !this.state.isExpanded })

  getExpansionButton() {
    return this.state.isExpanded ? <FontAwesomeIcon icon='minus'/> : <FontAwesomeIcon icon='plus'/>
  }

  render() {
    const { code, description, incompletePercentage, greatStrugglePercentage, strugglePercentage, noStrugglePercentage, isContainerExpanded, seps, dcis, cccs } = this.props

    return(
      <div className='performance-expectation-row'>
        <div className='pe-code'>{code}</div>
        <div className={this.getProgressColumnClasses()}>
          <WorkProductQualityProgressBar
            incompletePercentage={incompletePercentage}
            greatStrugglePercentage={greatStrugglePercentage}
            strugglePercentage={strugglePercentage}
            noStrugglePercentage={noStrugglePercentage}
          />
          <div className='pe-description' dangerouslySetInnerHTML={{ __html: description }}></div>
          {isContainerExpanded &&
            <div onClick={this.handleToggleExpansion} className='expansion-button'>{this.getExpansionButton()}</div>
          }
          {this.state.isExpanded && isContainerExpanded &&
            <div className='ngss-tables'>
              <NgssDimensionTable type='sep' dimensionItems={seps}/>
              <NgssDimensionTable type='dci' dimensionItems={dcis}/>
              <NgssDimensionTable type='ccc' dimensionItems={cccs}/>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default PerformanceExpectationRow
